import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";

import TooltipContainer from "@/components/Tooltip.vue";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component({
  components: {
    TooltipContainer
  }
})
export default class TalkToMeJrTaskList extends Vue {
  private _enableTask!: boolean;
  private audioLoc =
    "/res/protected/t2mejr_instructions/ttmj_tasklist_autoplay.mp3";

  created() {
    this._enableTask = false;
    this.$store.dispatch("setClip", {
      path: this.audioLoc,
      callbackFunction: () => {
        this._enableTask = true;
        this.$forceUpdate();
      }
    });
    this.$forceUpdate();
  }

  destroy() {
    this.$store.dispatch("removeClip", this.audioLoc);
  }

  render(h: CreateElement) {
    let tasks = (item: {
      imgLink: string;
      name: string;
      link: string;
      tooltip: string;
      bottom?: boolean;
      disabled?: boolean;
    }) => {
      return (
        <v-col cols="12" sm="4">
          <TooltipContainer bottom={item.bottom} data={item.tooltip}>
            <v-card
              class="mx-auto text-center"
              to={{ name: item.link }}
              max-width="180"
              disabled={!this._enableTask || item.disabled}
            >
              <v-img
                src={item.imgLink}
                style={{ width: "100px", margin: "auto" }}
                height="100px"
              />
              <v-card-title
                class="mx-auto"
                style={{
                  fontSize: "14px",
                  margin: `0 0 0 10px`,
                  padding: `0 10px 0 14px`
                }}
              >
                {item.name}
              </v-card-title>
            </v-card>
          </TooltipContainer>
        </v-col>
      );
    };

    let taskItem = [
      {
        imgLink: require("@/assets/oral-reading-fluency.png"),
        name: "Oral Reading Fluency",
        link: "t2mejr-orf",
        tooltip: "I can read stories our loud.",
        disabled: this.$store.getters.ttmjSections[2].progress == 100
      },
      {
        imgLink: require("@/assets/Pattern-Reasoning.png"),
        name: "Pattern Reasoning",
        link: "t2mejr-pattern",
        tooltip: "I can solve puzzles.",
        disabled: this.$store.getters.ttmjSections[3].progress == 100
      },
      {
        imgLink: require("@/assets/Picture-Description.png"),
        name: "Picture Description",
        link: "t2mejr-pic",
        tooltip: "I can tell stories from pictures.",
        disabled: this.$store.getters.ttmjSections[4].progress == 100
      },
      {
        imgLink: require("@/assets/Working-Memory.png"),
        name: "Working Memory",
        link: "t2mejr-workmem",
        tooltip: "I can remember lists of words.",
        bottom: true,
        disabled: this.$store.getters.ttmjSections[5].progress == 100
      },
      {
        imgLink: require("@/assets/Elision.png"),
        name: "Elision",
        link: "t2mejr-ellision",
        tooltip: "I can say words without same sounds.",
        bottom: true,
        disabled: this.$store.getters.ttmjSections[6].progress == 100
      },
      {
        imgLink: require("@/assets/Story-Retell.png"),
        name: "Story Retell",
        link: "t2mejr-retell",
        tooltip: "I can retell stories.",
        bottom: true,
        disabled: this.$store.getters.ttmjSections[7].progress == 100
      }
    ];
    const elements = taskItem.map(e => tasks(e));
    return (
      <Card
        title="Talk2MeJr. Activities"
        subtitle="Innovative AI Assessment Tool for Language and Learning"
        mod={Module.TTMJ}
      >
        <div slot="mainContent">
          <p class="subtitle-2">
            Talk2Me Jr. consists of the 6 language and cognitive activities
            shown below. You will complete each activity by speaking into a
            microphone or selecting options with a mouse. These activities could
            take around 20-30 minutes. {" "}
          </p>
          <p>Click on the activities below to get started.</p>
          <v-container fluid>
            <v-row dense>{elements}</v-row>
          </v-container>
        </div>
      </Card>
    );
  }
}

const component = TalkToMeJrTaskList;
